export const NAME = "public/signUp";

export const REFERRAL_CODE_SEARCH_PARAM = "referral" as const;
export const EHUB_REFERRAL_CODE_SEARCH_PARAM = "ehub" as const;
